import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export function ExperienceSection({ form, set }) {
  return (
    <div className="bg-white p-6 rounded-2xl border border-neutral-200/70 space-y-4">
      <h2 className="font-display font-semibold text-lg">Experience</h2>
      <div className="grid sm:grid-cols-3 gap-4">
        <div><Label>Years of experience</Label><Input type="number" min="0" value={form.years_experience} onChange={(e) => set("years_experience", e.target.value)} data-testid="careers-years"/></div>
        <div className="sm:col-span-2"><Label>Past employers (last 3)</Label><Input value={form.past_employers} onChange={(e) => set("past_employers", e.target.value)} placeholder="Restaurant A, Restaurant B, …" data-testid="careers-past-employers"/></div>
      </div>
      <div><Label>What restaurant / food-service experience do you have?</Label><Textarea rows={3} value={form.food_service_experience} onChange={(e) => set("food_service_experience", e.target.value)} data-testid="careers-food-exp"/></div>
      <div><Label>What is your biggest strength, and what is one area you're working to improve?</Label><Textarea rows={2} value={form.skill_to_improve} onChange={(e) => set("skill_to_improve", e.target.value)} data-testid="careers-skill"/></div>
    </div>
  );
}
